import { useEffect, useState } from "react"
import { req } from "./ServerUtils"


export function PrettyConversation({}) {
    const conversationId = window.location.pathname.split('/').pop();
    const [conversation, setConversation] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        req(`/pretty-conversation/${conversationId}`)
            .then(data => {
                console.log(data)
                setConversation(data.map(msg => {
                    try {
                        const parsed = JSON.parse(msg)
                        if (parsed) {
                            return msg.split('\\n');
                        }
                    } catch(e) {
                        return msg.split('\n');
                    }
                }))
                setLoading(false)
            })
    }, [])
    return (
        <div style={{
            padding: "20px",
            maxWidth: "800px",
            margin: "0 auto",
        }}>
            {loading ? <p>Loading...</p> : 
                <div>
                    {conversation.map(msg => 
                    <div style={{
                        padding: "20px",
                        marginBottom: "10px",
                        borderBottom: "1px solid #ccc",
                    }}>
                        {msg.map(line => <p>{line}</p>)}
                    </div>)}
                </div>}
        </div>
    )
}